"use client";

import HelpContactPage from "@components/help/HelpContact";
import { useUserInfo } from "@/hooks/userInfo";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { Skeleton } from "@repo/ui/components/ui/skeleton";

export default function HelpContact() {
  const { data: user, isLoading: userLoading } = useUserInfo();
  const params = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const searchParams = new URLSearchParams(params.toString());

  useEffect(() => {
    if (user?.firstName) {
      searchParams.set("firstName", user.firstName);
    }

    if (user?.lastName) {
      searchParams.set("lastName", user.lastName);
    }

    if (user?.email) {
      searchParams.set("email", user.email);
    }

    if (user?.firstName || user?.lastName || user?.email) {
      router.replace(pathname + "?" + searchParams.toString());
    }
  }, [user]);

  return (
    <>
      {userLoading ? <Skeleton className="w-full h-96" /> : <HelpContactPage />}
    </>
  );
}
